import type { ReactNode } from 'react';
import { Box, Stack } from '@mui/material';

interface TwoColumnProps {
  controls: ReactNode;
  preview: ReactNode;
}

// Controls on the left, a live rendering of what they produce on the right
// — matches Scouting Ops Hub's Website > Style tab layout (see
// scoutingops-hub/src/components/app/website-settings/style-section.tsx's
// own TwoColumn), now that the drawer is wide enough to fit it. Stacks on
// narrow viewports, same as Hub's.
export function TwoColumn({ controls, preview }: TwoColumnProps) {
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3}>
      <Stack spacing={2} sx={{ flex: 1, minWidth: 0 }}>
        {controls}
      </Stack>
      <Box sx={{ flex: 1, minWidth: 0 }}>{preview}</Box>
    </Stack>
  );
}
